module.exports = __webpack_public_path__ + "img/bigfive_c2.1af3b140.png";